import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const CheckboxUserContainerStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "checkbox-user-container",
})<{ $color?: string }>`
  cursor: pointer;
  line-height: 1px;
  ${({ $color }) =>
    $color &&
    `
    svg path {
      fill: ${$color};
    }
  `}
`;

export const CheckboxUserEditContainerStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "checkbox-user-edit-container",
  },
)`
  cursor: pointer;
  line-height: 1px;
`;

export const CheckboxControlledMuiContainerStyled = styled.span.attrs<IStyledAttributes>(
  {
    "data-e2e": "checkbox-controlled-mui-container",
  },
)`
  cursor: pointer;
  vertical-align: middle;
  line-height: 1px;
  padding: 1px;
`;

export const CheckboxControlledContainerStyled = styled.span.attrs<IStyledAttributes>(
  {
    "data-e2e": "checkbox-controlled-container",
  },
)`
  cursor: pointer;
  vertical-align: middle;
  line-height: 1px;
`;

export const CheckboxStarContainer = styled.span.attrs<IStyledAttributes>({
  "data-e2e": "checkbox-star-container",
})<{ width: number; height: number }>`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  cursor: pointer;
  vertical-align: middle;
  line-height: 1px;
`;

export const CheckboxMuiContainerStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "checkbox-mui-container",
})`
  cursor: pointer;
  vertical-align: middle;
  line-height: 1px;
  padding: 1px;
`;
